import React from 'react';
import { NamedLink } from '../../../components';
import { DIGO_WORKER_USER_TYPE, signupLinkProps } from '../digoServices';
import css from './SectionRecruitDigo.module.css';

const PERKS = [
  "Accès gratuit à des centaines d'offres de travail",
  'Aucun abonnement payant',
  'Fixe tes propres horaires et ton propre tarif',
  'Développe ta clientèle et ta réputation',
];

const CHECK_CIRCLE_PATH = [
  'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75',
  '-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z',
  'm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22',
  'a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z',
].join(' ');

const CheckCircleIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" focusable="false" aria-hidden="true">
    <path fillRule="evenodd" d={CHECK_CIRCLE_PATH} clipRule="evenodd" />
  </svg>
);

const SectionRecruitDigo = () => (
  <section className={css.root}>
    <div className={css.container}>
      {/* Colonne gauche — recrutement */}
      <div className={css.left}>
        {/* <div className={css.badge}>Travailleur autonome</div> */}
        <h2 className={css.title}>Sois ton propre patron</h2>
        <p className={css.subtitle}>
          Que tu sois expert en déneigement ou pro du ménage, trouve ton prochain contrat sur Digo.
        </p>

        <ul className={css.perks}>
          {PERKS.map((p, i) => (
            <li key={i} className={css.perk}>
              <span className={css.perkCheck} aria-hidden="true">
                <CheckCircleIcon />
              </span>
              {p}
            </li>
          ))}
        </ul>

        <NamedLink {...signupLinkProps(DIGO_WORKER_USER_TYPE)} className={css.cta}>
          Devenir travailleur DIGO
        </NamedLink>

        {/* <div className={css.earningNote}>
          500+ travailleurs gagnent déjà avec DIGO au Québec.
        </div> */}
      </div>

      {/* Colonne droite — photo */}
      <div className={css.right}>
        <div className={css.photoWrap}>
          <img
            src="/static/digo-gazon.webp"
            alt="Travailleur Digo tondant une pelouse"
            className={css.photo}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
);

export default SectionRecruitDigo;
